import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';

import { Title } from '@restworld/ui-ds';

import { workerTrainingsAtom } from '../../../../employer-job-listing.atoms';
import { TabCardWrapper } from '../candidate-profile-section';
import { StyledSeparator } from './worker-experience';
import { TrainingSectionItem } from './training-section-item';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ITrainingSectionProps {}

const TrainingSection: React.FunctionComponent<ITrainingSectionProps> = (props) => {
  const workerTrainings = useAtomValue(workerTrainingsAtom);
  const itemsCount = workerTrainings?.length || 0;
  const { t } = useTranslation('onboarding-page');

  return (
    <TabCardWrapper title={t('training')}>
      <div tw="flex flex-col items-start pt-4">
        {workerTrainings?.map((workerTraining, index) => (
          <div tw="w-full" key={index} id={`education-${index}`}>
            <TrainingSectionItem key={index} {...{ workerTrainingIndex: index, workerTraining }} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
        {!workerTrainings?.length && (
          <Title fontWeight="normal" textColor="gray-500" variant="h6-large">
            {t('missing_info')}
          </Title>
        )}
      </div>
    </TabCardWrapper>
  );
};

export default TrainingSection;
